import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function MoreZoomIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "12"}
      height={height || "12"}
      viewBox="0 0 12 12"
    >
      <path
        id="Caminho_10306"
        data-name="Caminho 10306"
        d="M9.773,13.6h5.455l.982,2.4H18.5L13.318,4H11.682L6.5,16H8.791ZM12.5,6.16l2.04,5.476H10.46Z"
        transform="translate(-6.5 -4)"
        fill={color || "#555"}
      />
    </svg>
  );
}
